module.exports = __webpack_public_path__ + "media/images/flags/gl-f260d3a183ea29d01cabf878aaaaf8b1.svg";